import { useState, useEffect, useCallback } from "react";
import THEME from "../../../theme";
import { fs } from "../utils/styles";
import { finanzenApi } from "../services/finanzenApi";

const TYPEN = [
  { value: "einnahme", label: "Einnahme" },
  { value: "ausgabe", label: "Ausgabe" },
  { value: "neutral", label: "Neutral" },
];

export default function FinanzKategorienSeite({ benutzerId }) {
  const [kategorien, setKategorien] = useState([]);
  const [form, setForm] = useState({ name: "", kategorie_typ: "ausgabe" });
  const [fehler, setFehler] = useState("");
  const [speichert, setSpeichert] = useState(false);

  const laden = useCallback(() => {
    finanzenApi.kategorienListe(benutzerId).then(setKategorien).catch(e => setFehler(e.message));
  }, [benutzerId]);

  useEffect(() => { laden(); }, [laden]);

  const erstellen = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) return;
    setSpeichert(true);
    setFehler("");
    try {
      await finanzenApi.kategorieErstellen(benutzerId, form);
      setForm({ name: "", kategorie_typ: "ausgabe" });
      laden();
    } catch (e) {
      setFehler(e.message);
    }
    setSpeichert(false);
  };

  const loeschen = async (id) => {
    if (!window.confirm("Kategorie wirklich entfernen?")) return;
    try {
      await finanzenApi.kategorieLoeschen(benutzerId, id);
      laden();
    } catch (e) {
      setFehler(e.message);
    }
  };

  const gruppiert = TYPEN.map(t => ({ ...t, eintraege: kategorien.filter(k => k.kategorie_typ === t.value) }));

  return (
    <div>
      <form onSubmit={erstellen} style={{ ...fs.karte, display: "flex", gap: 12, alignItems: "flex-end", flexWrap: "wrap" }}>
        <div style={{ flex: 1, minWidth: 200 }}>
          <label style={fs.label}>Neue Kategorie</label>
          <input style={{ ...fs.input, width: "100%" }} value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} placeholder="z.B. Marketing" />
        </div>
        <div>
          <label style={fs.label}>Typ</label>
          <select style={fs.input} value={form.kategorie_typ} onChange={e => setForm(f => ({ ...f, kategorie_typ: e.target.value }))}>
            {TYPEN.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
          </select>
        </div>
        <button style={fs.btn} type="submit" disabled={speichert}>{speichert ? "Speichert…" : "Hinzufügen"}</button>
      </form>

      {fehler && <p style={{ color: THEME.colors.danger }}>{fehler}</p>}

      {gruppiert.map(gruppe => (
        <div key={gruppe.value} style={fs.karte}>
          <h3 style={{ color: THEME.colors.text, marginTop: 0 }}>{gruppe.label} ({gruppe.eintraege.length})</h3>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
            {gruppe.eintraege.map(k => (
              <span key={k.id} style={{
                display: "flex", alignItems: "center", gap: 8, padding: "6px 12px", borderRadius: THEME.radius.md,
                background: THEME.colors.surfaceMuted, color: THEME.colors.text, fontSize: THEME.fontSize.sm,
              }}>
                {k.name}
                <button onClick={() => loeschen(k.id)} title={k.ist_system_kategorie ? "Deaktivieren" : "Löschen"}
                  style={{ background: "none", border: "none", color: THEME.colors.textMuted, cursor: "pointer", padding: 0, fontSize: THEME.fontSize.sm }}>×</button>
              </span>
            ))}
            {gruppe.eintraege.length === 0 && <span style={{ color: THEME.colors.textMuted }}>Keine Kategorien.</span>}
          </div>
        </div>
      ))}
    </div>
  );
}
